import styled from 'styled-components';
import { FontSize, inputStyle, spacing } from 'commons';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: min-content;
`;

export const ProductWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.neutral_300};
  border-radius: 8px;
`;

export const ReturnProductWrapper = styled.div`
  display: flex;
  flex: 1;
  min-width: 280px;
`;

export const ReasonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-width: 280px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DisplayText = styled.div`
  display: grid;
  overflow-x: hidden;

  & > :first-child {
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  align-items: center;
  color: ${({ theme }) => theme.neutral_700};
  border: 1px solid ${({ theme }) => theme.neutral_300};
  padding: 12px 16px;
  min-height: ${spacing.input.height};
  border-radius: 8px;
  overflow-x: hidden;
  text-overflow: ellipsis;
`;

export const TextArea = styled.textarea`
  resize: vertical;
  min-height: ${spacing.input.height};
  border-radius: ${spacing.input.borderRadius};
  border: 1px solid ${({ theme }) => theme.neutral_300};
  font-size: ${FontSize.font12};
  font-weight: ${inputStyle.fontWeight};
  padding: 16px;
  color: ${({ theme }) => theme.neutral_500};

  overflow-x: hidden;
  text-overflow: ellipsis;

  &::placeholder {
    opacity: ${inputStyle.placeholderOpacity};
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;
